class MixHero extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.init();
    }
    init() {
        this.setup();
        this.interact()
    }
    setup() {
        this.tl = gsap.timeline({
            delay: .5,
            onStart: () => {
                this.querySelectorAll('[data-init-df]').forEach((el) => { el.removeAttribute('data-init-df') });
            },
        })
        new MasterTimeline({
            triggerInit: this,
            timeline: this.tl,
            tweenArr: [
                new RevealText({ el: this.querySelector('.mix-hero-title .txt'), color: 'black', allowMobile: true }),
                new RevealText({ el: this.querySelector('.mix-hero-sub .txt'), color: 'rgba(29, 29, 29, 0.80)', isFast: true, allowMobile: true })
            ]
        })
    }
    interact() { 
        this.querySelectorAll('[data-init-df]').forEach((el) => { el.removeAttribute('data-init-df') });
        
        const itemVegates = this.querySelectorAll('.mix-hero-veget-item'); 
 
        itemVegates.forEach((item) => { 
            item.classList.add('start-anim');
            const imgInner = item.querySelector('img');
            gsap.from(item, {
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                duration: 2,
                ease: 'power3',
                clearProps: 'all'
            });
            gsap.fromTo(imgInner, { 
                opacity: 0,
                scale: 0.2,
            }, {
                scale: 1,
                opacity: 1, 
                duration: 0.6,
                ease: 'power3.inOut'
            })
        })

    }
}

customElements.define('mix-hero', MixHero);